export default __webpack_public_path__ + "static/media/palvelut-darkblue.c04c21f4.svg";